import React, { useEffect, useState } from "react";
import Circle from "./Circle";
import "./ProgressBar.css";

const ProgressBar = ({ activeBar }) => {
  const [widthBar, setWidthBar] = useState(0);

  useEffect(() => {
    setWidthBar((100 / (2)) * activeBar);
  }, [ activeBar]);

  const arrBar = [];
  for (let i = 0; i < 3; i++) {
    arrBar.push(
      <Circle
        cName={
          i < activeBar
            ? "circleBar lastActiveBar"
            : i === activeBar
            ? "circleBar activeBar"
            : "circleBar"
        }
        key={i}
      ></Circle>
    );
  }

  const progressText = ["Solicitar", "Definir RUT", "Confirmar"];

  return (
    <div className="progresBarAmplify">
      <div className="progressBar">
        <div className="progress" style={{ width: widthBar + "%" }}></div>
        {arrBar}
      </div>

      <div className="progressContainerText">
        {progressText.map((text, index) => (
          <p
            className={
              index < activeBar
                ? "lastActiveBar"
                : index === activeBar
                ? "activeBar"
                : ""
            }
            key={index}
          >
            {text}
          </p>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
